export const iaOrigenRecomendados = {
  listados: 'ia_listados',
  dashboard: 'ia_dashboard',
  postPostulacion: 'ia_post_postulacion',
  onBoarding: 'ia_onboarding',
}
